// §11 — the built-in apps (D-018).
//
// Each is an in-process app (§9.1) reaching the kernel only through the `HangarAPI` it is
// handed; none of them imports `kernel/**` or a skin (§6.5). This barrel is the one list the
// shell registers, so "which built-ins exist" has a single answer.
import type { InProcessApp } from '@hangar/shared';
import { calculatorApp } from './calculator';
import { browserApp } from './browser';
import { solitaireApp } from './solitaire';
import { game2048App } from './2048';
import { beltApp } from './belt';
import { chompApp } from './chomp';
import { skipperApp } from './skipper';
import { wayfarerApp } from './wayfarer';

// §25.2 (D-202) — Solitaire joins the unconditional built-ins because it is the one Arcade title
// a guest may play. The other eight carry `requiresAuth: true`, so `kernel.apps.visible()`
// (§24.11, D-200) is what keeps them off a guest's desktop — registration cannot do it, because
// `buildKernel()` runs before identity is known.
//
// **Cascade, Conquest and Intercept are absent from this list on purpose.** All three hold a D-059
// capability, so they are factories rather than constants and `App.tsx` registers them beside the
// other capability-holding built-ins — which is where the whole list of who was granted what is.
// §34.1 / D-511 — **Workbench's apps are absent from this list on purpose**, like Cascade,
// Conquest and Intercept: Archive holds a D-059 capability *and* is lazy, so it is a factory
// registered in `App.tsx` beside the other capability holders — which is where the whole list of
// who was granted what lives. §34.6's Media is there for the same reason (D-520): §34.6 requires
// §15's global mute to reach it and `HangarAPI` carries no settings surface, so it is a factory too.
// §34.3 (D-541) — **Notepad is absent from this list since M57.2**, for the same reason: the
// markdown preview reads a §14 setting and the images a document points at, so it holds a capability
// and is registered in `App.tsx`. It is still an *eager* app; only the preview arrives lazily.
export const BUILTIN_APPS: readonly InProcessApp[] = [
  calculatorApp,
  browserApp,
  solitaireApp,
  game2048App,
  beltApp,
  chompApp,
  skipperApp,
  wayfarerApp,
];
